var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "訂單編號",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "orderno"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入訂單編號" },
                            model: {
                              value: _vm.model.orderno,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "orderno", $$v)
                              },
                              expression: "model.orderno"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "供應商",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "supplier"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入供應商" },
                            model: {
                              value: _vm.model.supplier,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "supplier", $$v)
                              },
                              expression: "model.supplier"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "商品編碼",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "productId"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入商品ID" },
                            model: {
                              value: _vm.model.productId,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "productId", $$v)
                              },
                              expression: "model.productId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "商品名稱",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "productName"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入商品名稱" },
                            model: {
                              value: _vm.model.productName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "productName", $$v)
                              },
                              expression: "model.productName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "商品數量",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "prodnum"
                          }
                        },
                        [
                          _c("a-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请输入商品數量" },
                            model: {
                              value: _vm.model.prodnum,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "prodnum", $$v)
                              },
                              expression: "model.prodnum"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "商品單價",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "price"
                          }
                        },
                        [
                          _c("a-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请输入商品單價" },
                            model: {
                              value: _vm.model.price,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "price", $$v)
                              },
                              expression: "model.price"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "點數",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "points"
                          }
                        },
                        [
                          _c("a-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请输入點數" },
                            model: {
                              value: _vm.model.points,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "points", $$v)
                              },
                              expression: "model.points"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "配送日期",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "deliverTitle"
                          }
                        },
                        [
                          _c("a-input", {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请输入配送日期" },
                            model: {
                              value: _vm.model.deliverTitle,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "deliverTitle", $$v)
                              },
                              expression: "model.deliverTitle"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "員工工號",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "empId"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入員工工號" },
                            model: {
                              value: _vm.model.empId,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "empId", $$v)
                              },
                              expression: "model.empId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "員工姓名",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "empName"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入員工姓名" },
                            model: {
                              value: _vm.model.empName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "empName", $$v)
                              },
                              expression: "model.empName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "所屬法人",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "empCompany"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入所屬法人" },
                            model: {
                              value: _vm.model.empCompany,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "empCompany", $$v)
                              },
                              expression: "model.empCompany"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "付費法人",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "payingLegalPerson"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入付費法人" },
                            model: {
                              value: _vm.model.payingLegalPerson,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "payingLegalPerson", $$v)
                              },
                              expression: "model.payingLegalPerson"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "收件人",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "recipient"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入收件人" },
                            model: {
                              value: _vm.model.recipient,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "recipient", $$v)
                              },
                              expression: "model.recipient"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "收件人手機號",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "empMobile"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入收件人手機號" },
                            model: {
                              value: _vm.model.empMobile,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "empMobile", $$v)
                              },
                              expression: "model.empMobile"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "收件人固話",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "empPhone"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入收件人固話" },
                            model: {
                              value: _vm.model.empPhone,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "empPhone", $$v)
                              },
                              expression: "model.empPhone"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "郵箱地址",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "empEmail"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入郵箱地址" },
                            model: {
                              value: _vm.model.empEmail,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "empEmail", $$v)
                              },
                              expression: "model.empEmail"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "收件地址",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "empAddress"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入收件地址" },
                            model: {
                              value: _vm.model.empAddress,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "empAddress", $$v)
                              },
                              expression: "model.empAddress"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "是否寄收據",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "sendReceipt"
                          }
                        },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.model.sendReceipt,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "sendReceipt", $$v)
                              },
                              expression: "model.sendReceipt"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "捐款人證件號",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "code"
                          }
                        },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.model.code,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "code", $$v)
                              },
                              expression: "model.code"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "捐款人生日",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "birthdayValue"
                          }
                        },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.model.birthdayValue,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "birthdayValue", $$v)
                              },
                              expression: "model.birthdayValue"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "訂單備註",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "noteMessage"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入訂單備註" },
                            model: {
                              value: _vm.model.noteMessage,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "noteMessage", $$v)
                              },
                              expression: "model.noteMessage"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "是否代收",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "adminCollect"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入是否代收" },
                            model: {
                              value: _vm.model.adminCollect_dictText,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "adminCollect_dictText",
                                  $$v
                                )
                              },
                              expression: "model.adminCollect_dictText"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "活動編碼",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "app"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入活動編碼" },
                            model: {
                              value: _vm.model.app,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "app", $$v)
                              },
                              expression: "model.app"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "活動名稱",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "appName"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入活動名稱" },
                            model: {
                              value: _vm.model.appName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "appName", $$v)
                              },
                              expression: "model.appName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }